import script from "./CategoriaLista.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaLista.vue?vue&type=script&setup=true&lang=js"

import "./CategoriaLista.vue?vue&type=style&index=0&id=65504fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65504fd2"]])

export default __exports__